/**
 * Custom header scroll behavior for LALEBU.
 * Detects scroll and toggles transparent → solid white header.
 */
(function () {
  var headerGroup = document.getElementById('header-group');
  var header = document.getElementById('header-component');
  if (!headerGroup) return;

  var threshold = 50;

  function onScroll() {
    if (window.scrollY > threshold) {
      headerGroup.classList.add('header-scrolled');
      if (header) header.setAttribute('data-sticky-state', 'active');
    } else {
      headerGroup.classList.remove('header-scrolled');
      if (header) header.removeAttribute('data-sticky-state');
    }
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();
})();
